import { render, staticRenderFns } from "./DeleteWarning.vue?vue&type=template&id=2841eb98&"
import script from "./DeleteWarning.vue?vue&type=script&lang=js&"
export * from "./DeleteWarning.vue?vue&type=script&lang=js&"
import style0 from "./DeleteWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports